import { createSelector } from 'reselect';
import { updateFastShippingCopyMeganavSMSelector } from 'selectors/testTarget/offers/updateFastShippingCopyMeganavSM/updateFastShippingCopyMeganavSMSelector';

const experienceSelector = createSelector(
    updateFastShippingCopyMeganavSMSelector,
    updateFastShippingCopyMeganavSM => updateFastShippingCopyMeganavSM.experience
);

export { experienceSelector };
